import React from 'react'
import { CardBrand } from './types'
import DefaultCard from '../icons/Cards/DefaultCard'
import Visa from '../icons/Cards/Visa'
import Mastercard from '../icons/Cards/Mastercard'
import Amex from '../icons/Cards/Amex'
import Discover from '../icons/Cards/Discover'
import { CardIconWrapper } from './styles'

interface CardIconProps {
  cardBrand: CardBrand
}

const CardIcon: React.FC<CardIconProps> = ({ cardBrand }) => {
  let Icon = DefaultCard
  switch (cardBrand) {
    case 'Visa':
      Icon = Visa
      break
    case 'MasterCard':
      Icon = Mastercard
      break
    case 'American Express':
      Icon = Amex
      break
    case 'Discover':
      Icon = Discover
      break
  }

  return (
    <CardIconWrapper>
      <Icon />
    </CardIconWrapper>
  )
}

export default CardIcon
